"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TravelFooter = function TravelFooter(props) {
  var user = props.user,
      contactLink = props.contactLink;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "travel--footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "travel--footer__inner"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Contact us today to save money on your next trip!"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "tel:".concat(user === null || user === void 0 ? void 0 : user.phone)
  }, user === null || user === void 0 ? void 0 : user.phone), contactLink)));
};

var _default = TravelFooter;
exports["default"] = _default;